import { Grid } from '@mui/material';
import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { quickInputSelector } from '../QuickInput/reducers/QuickInputReducer';
import './Investment.scss';
import { InvestmentInputSelector, setTriggerRefreshInput, setTriggerSave } from './reducers/InvestmentInputReducer';
import { setTriggerInvestmentSearch } from './reducers/InvestmentSearchReducer';
import InvestmentTable from './InvestmentTable';
import InvestmentInput from './InvestmentInput';

let triggerHotkeyAlready = false;

const Investment: React.FunctionComponent = () => {
    const dispatch = useDispatch();
    const quickInputData = useSelector(quickInputSelector);
    const InvestmentInputViewData = useSelector(InvestmentInputSelector);

    useEffect(() => {
        document.title = "Investment";

        // attach the event listener
        document.addEventListener('keydown', handleKeyPress);
    }, []);

    const handleKeyPress = useCallback((event) => {
        if (!triggerHotkeyAlready) {
            if (event.altKey) {
                switch (event.key) {
                    case "s":
                        //save
                        triggerHotkeyAlready = true;
                        dispatch(setTriggerSave((new Date()).getTime()));
                        break;
                    case "r":
                        //refresh save
                        dispatch(setTriggerRefreshInput((new Date()).getTime()));
                        break;
                    case "w":
                        //search
                        triggerHotkeyAlready = true;
                        dispatch(setTriggerInvestmentSearch((new Date()).getTime()));
                        break;
                    default:
                        break;
                }
            }

            setTimeout(() => {
                triggerHotkeyAlready = false;
            }, 2000);
        }
    }, []);

    return (
        <>
            <Grid container className="tonnage">
                <Grid container className="input-fields">
                    <div className={quickInputData.showQuickInput ? "tonnage-quick-input-collapse" : "tonnage-quick-input-expand"}>
                        <InvestmentInput></InvestmentInput>
                    </div>
                </Grid>
                <Grid container className="datatable">
                    <InvestmentTable>
                    </InvestmentTable>
                </Grid>
            </Grid>
        </>
    )
};

export default Investment;